import { graphql, useFragment } from 'react-relay';

import { SchoolExamSourceUploadDifferenceItemList_difference$key } from '../../../relay/__generated__/SchoolExamSourceUploadDifferenceItemList_difference.graphql';
import { isNullable } from '../../../utils/is';
import EmptyState from '../../core/EmptyState';
import ItemList from '../../core/ItemList';
import LinkButton from '../../core/LinkButton';
import Text from '../../core/Text';
import View from '../../core/View';
import DiffItem from '../../difference/DiffItem';

const SchoolExamSourceUploadDifferenceItemList_difference = graphql`
  fragment SchoolExamSourceUploadDifferenceItemList_difference on Difference {
    ... on SchoolExamSourceUploadDifference {
      innerPdf {
        ...DiffItem_diff
      }
    }
  }
`;

type Props = { difference: SchoolExamSourceUploadDifferenceItemList_difference$key };

const SchoolExamSourceUploadDifferenceItemList = ({ difference }: Props) => {
  const { innerPdf } = useFragment(SchoolExamSourceUploadDifferenceItemList_difference, difference);

  const diffItems = [
    {
      title: `내부 업로드`,
      diff: innerPdf,
      renderItem: (beforeOrAfter: string) =>
        beforeOrAfter ? <LinkButton href={beforeOrAfter}>PDF 열기</LinkButton> : null,
    },
  ].filter(({ diff }) => !isNullable(diff));
  return (
    <ItemList
      items={diffItems}
      renderItem={({ title, diff, renderItem }) => (
        <>
          <Text sx={{ fontSize: 1, fontWeight: 'bold' }}>{title}</Text>
          <View sx={{ marginTop: 2 }}>
            <DiffItem diff={diff!} renderItem={renderItem} />
          </View>
        </>
      )}
      renderItemWrapper={(children, { title }, i) => (
        <View key={title} sx={{ marginTop: i > 0 ? 3 : 0 }}>
          {children}
        </View>
      )}
      emptyState={
        <View sx={{ paddingY: 6 }}>
          <EmptyState
            title={'기록되지 않은 히스토리이에요'}
            description={'이 기능이 만들어지기 전에 일어난 일이거나 오류로 누락된 히스토리입니다.'}
          />
        </View>
      }
    />
  );
};

export default SchoolExamSourceUploadDifferenceItemList;
